import store from "@/store";

export async function authMiddleware(to, from, next) {
  const isAuthorized = store.getters["user/isAuthorized"];
  // если есть токен но мы не авторизованы
  if (!isAuthorized) {
    try {
      await store.dispatch("user/getMe");
    } catch (error) {
      return next();
    }
  }
  return next();
}
